import React, { Component } from 'react';
import classnames from 'classnames';
import {Config} from '../../util';
import _ from 'lodash';
const List = ({data, item, showTooltip, handleErrorMsg, pathList, fmtList}) => {
    const downName = (id) => {
        const newList = _.keyBy(fmtList, 'ID');
        const name = newList[item.FMTID] && id ? `${id} (${newList[item.FMTID].NAME})` : `${id}`;
        return name;
    }
    const memoValue = (id) => {
        const newList = _.keyBy(pathList, 'ID');
        const name = newList[item.PATHID] && id ? `${id} / ${newList[item.PATHID].PATHNAME}` : `${id}`;
        return name;
    }

    const chName = (id) => {
        const chName =_.keyBy(Config.logoUrl, 'epgId')[id] &&  _.keyBy(Config.logoUrl, 'epgId')[id].id;
        
        // if(sessionStorage.getItem('chList')){
        //     const chList = JSON.parse(sessionStorage.getItem('chList'));
        //     const chIdKey = _.keyBy(chList, 'chId');
        //     return chIdKey[id].chName;
        // }
        
        return chName;
    }
    const tdType = {
        className: classnames(data.id.toLowerCase(), {'error-color': item[data.id] === "E" && data.id === "STATE"}),
        onClick: item[data.id] === "E" && data.id === "STATE" ? handleErrorMsg : null
    };
    const typeValue = (type) => {
        switch(type){
            case 'P':
                return "진행";
            case 'D':
                return "완료";
            case 'E':
                return "오류";
            default:
                return "대기";
        }
    };
    const listItem = () => {
        switch(data.id){
            case "ODT":
                return item.ODT.slice(0, item.ODT.lastIndexOf(":"));
            // case "SCHID":
            case "EPGID":
                return chName(item[data.id]);
            case "STATE":
                return typeValue(item[data.id]);
            case "DOWNNAME":
                return downName(item[data.id]);
            case "MEMO":
                return memoValue(item[data.id]);
            default:
                return item[data.id];
        }
        
    };
  
    // if(item[data.id] === "E" && data.id === "STATE" && item.MSG)
    //     return <td {...tdType}>{listItem()} 
    //                 <div className={classnames("errmsg", {'is-view': showTooltip})} appended="true">{item.MSG}
    //                     <div onClick={handleMsgClose}>x</div>
    //                 </div> 
    //             </td>;
    // else
        return <td {...tdType}>{listItem()}</td>;
   
}

class ListContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            showTooltip: false
        };
        this.handleErrorMsg = this.handleErrorMsg.bind(this);
    }
  
    handleErrorMsg(){
        const error_d = "Error \nMessage : " + this.props.item.MSG;
        alert(error_d);
    }
    
    render() {
        const {
            showTooltip
        } = this.state;
        const {
            item,
            headerData,
            pathList,
            fmtList
        } = this.props;
      
        
        
        return (
            <tr className={classnames('body', {'error': item.STATE === 'E'})}>
                {headerData.map ((data) => 
                    <List data={data} item={item} key={`td_${item.NUM}_${data.id}`}
                        showTooltip={showTooltip}
                        pathList={pathList}
                        fmtList={fmtList}
                        handleErrorMsg={this.handleErrorMsg}
                    />
                )}
                
            </tr>
        );
    }
}

export default ListContainer;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/ListContainer.js